// extracted by mini-css-extract-plugin
export default {"wrap":"EmailSignaturePreview_wrap__35wrR","content":"EmailSignaturePreview_content__5A8jy"};